import React from "react";
import classnames from "classnames/bind";

import Icon from "@components/icon";

import strings from "../../../../locales/strings";

import styles from "../NotificationsList/NotificationsList.scss";

const cx = classnames.bind(styles);

const PaigerAd = () => (
  <div className={cx("get-message")}>
    <div className={cx("get-message-inner")}>
      <Icon
        name="ic_loads-search"
        className={cx("search-icon")}
        width={64}
        height={64}
      />
      <div className={cx("links-block")}>
        <b>{strings.downloadLoadsAndTrucks}</b>
        <p>{strings.receiveNotifications}</p>
        <div className={cx("links-apps")}>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://redirect.appmetrica.yandex.com/serve/748147146636700301"
            className={`-h-android-link ${cx("app-link")}`}
          >
            <Icon
              className={cx("market-icon")}
              name="ic_play-market"
              size="m"
            />
            {strings.forAndroid}
          </a>
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://redirect.appmetrica.yandex.com/serve/171686406714895379"
            className={`-h-ios-link ${cx("app-link")}`}
          >
            <Icon
              className={cx("market-icon")}
              name="ic_apple"
              size="m"
              color="var(--glz-color-neutral-tone-0)"
            />
            {strings.forIPhoneIPad}
          </a>
        </div>
      </div>
    </div>
  </div>
);

export default PaigerAd;
